import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';

const StickyBooking = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 600px
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 left-0 right-0 z-[100] px-4 md:px-0"
        >
          <div className="container-custom">
            <div className="bg-luxury-black/80 backdrop-blur-2xl border border-white/10 rounded-[2rem] p-3 md:p-4 flex flex-row items-center justify-between shadow-[0_20px_50px_rgba(0,0,0,0.3)]">
              
              <div className="flex items-center gap-4 ml-4">
                <div className="hidden md:flex w-10 h-10 rounded-full bg-orange-500 items-center justify-center">
                  <Calendar className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="text-white text-sm font-serif">A New Era of Luxury</h4>
                  <p className="text-white/50 text-[10px] uppercase tracking-widest hidden md:block">Malakpet, Hyderabad</p>
                </div>
              </div>

              <div className="flex items-center gap-3 md:gap-6">
                <div className="hidden lg:flex items-center gap-8 mr-6 border-r border-white/10 pr-8">
                  <div className="text-right">
                    <p className="text-white/40 text-[9px] uppercase tracking-widest font-bold">Best Rate</p>
                    <p className="text-orange-400 text-lg font-serif">₹3,500<span className="text-[10px] text-white/30 ml-1">/night</span></p>
                  </div>
                </div>
                
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-6 md:px-10 py-3 md:py-4 rounded-xl md:rounded-2xl font-bold text-[10px] md:text-xs tracking-[0.2em] transition-all flex items-center gap-3 group whitespace-nowrap"
                >
                  BOOK YOUR STAY
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>

            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyBooking;
